import { DayPilot } from "daypilot-pro-angular";

export const SupportedObjectTypes = {
  LiveFlightEvent: "LiveFlightEvent",
  ActivityActorEvent: "ActivityActorEvent",
}

export interface IDaypilotCoreEvent {
  id: string;
  text: string;
  start: DayPilot.Date;
  end: DayPilot.Date;
  resource: any;
  html: string;
  height: number;
  objectType: string;
}

export class DaypilotCoreEvent implements IDaypilotCoreEvent {
  public id: any;
  public text: string;
  public start: DayPilot.Date;
  public end: DayPilot.Date;
  public resource: any;
  public html: string;
  public height: number;
  public objectType: string;


  public constructor(
    id: string,
    text: string,
    start: Date,
    end: Date,
    resource: string,
    objectType: string)
  {
    this.id = id;
    this.text = text;
    this.start = new DayPilot.Date(start, true);
    this.end = new DayPilot.Date(end, true);
    this.resource = resource;
    this.objectType = objectType;
  }



}
